var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_2822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_2822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2222 56.6667C30.6761 56.6667 29.3636 56.1274 28.2847 55.0488C27.2061 53.9699 26.6667 52.6574 26.6667 51.1113V28.8888C26.6667 27.3546 27.2061 26.0451 28.2847 24.9604C29.3636 23.8757 30.6761 23.3333 32.2222 23.3333H53.3334V48.3333C52.6112 48.3333 52.014 48.6088 51.5417 49.1596C51.0695 49.7107 50.8334 50.3613 50.8334 51.1113C50.8334 51.8704 51.0695 52.5232 51.5417 53.0696C52.014 53.6157 52.6112 53.8888 53.3334 53.8888V56.6667H32.2222ZM32.2097 53.8888H48.7638C48.5416 53.4815 48.368 53.044 48.243 52.5763C48.118 52.1088 48.0555 51.6204 48.0555 51.1113C48.0555 50.5927 48.1158 50.1018 48.2363 49.6388C48.3566 49.176 48.5417 48.7408 48.7917 48.3333H32.2113C31.4408 48.3333 30.787 48.6033 30.2501 49.1433C29.7131 49.6836 29.4447 50.3396 29.4447 51.1113C29.4447 51.889 29.7131 52.5464 30.2501 53.0833C30.787 53.6203 31.4402 53.8888 32.2097 53.8888ZM29.4447 46.2917C29.8519 46.0417 30.2831 45.8565 30.7384 45.7363C31.194 45.6157 31.6886 45.5554 32.2222 45.5554H50.5555V26.1113H32.2222C31.4444 26.1113 30.787 26.3813 30.2501 26.9213C29.7131 27.4615 29.4447 28.1174 29.4447 28.8888V46.2917ZM34.5417 41.6667H36.5834L37.6251 38.7083H42.3334L43.3751 41.6667H45.4167L41.0001 30H38.9167L34.5417 41.6667ZM38.2084 37L39.9167 32.1667H40.0417L41.7501 37H38.2084Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowAddressBook);
export default __webpack_public_path__ + "static/media/icon-flow-address-book.edfad65805dd97509e3e22bc0cdbeab2.svg";
export { ForwardRef as ReactComponent };